module.exports = __webpack_public_path__ + "static/media/gimp.f9df1ce5.svg";